import Vue from "vue";
// @ts-ignore
import VuetifyMoney from "vuetify-money";

Vue.use(VuetifyMoney);
export default VuetifyMoney;